import * as React from 'react';
import styled, { css } from 'styled-components';

type PositionType = 'top-left' | 'top-right' | 'bottom-left' | 'bottom-right';
type DesignType = 'corner' | 'middle';

const OFFSET = -1;

const Wrapper = styled.div<{ $design: DesignType; $position: PositionType }>`
  &::before,
  &::after {
    content: '';
    display: block;
    position: absolute;
    background: ${({ theme }) => theme.highlightColor};
  }

  &::before {
    height: 11px;
    width: 1px;
  }

  &::after {
    width: 11px;
    height: 1px;
  }

  ${({ $position }) =>
    $position === 'top-left' &&
    css`
      &::before,
      &::after {
        top: ${OFFSET}px;
        left: ${OFFSET}px;
      }
    `}

  ${({ $position }) =>
    $position === 'top-right' &&
    css`
      &::before,
      &::after {
        top: ${OFFSET}px;
        right: ${OFFSET}px;
      }
    `}

    ${({ $position, $design }) =>
    $position === 'bottom-left' &&
    css`
      &::before,
      &::after {
        bottom: ${OFFSET}px;
        left: ${OFFSET}px;
      }

      ${$design === 'middle' &&
      css`
        &::before {
          height: 21px;
          bottom: -11px;
        }
      `}
    `}

    ${({ $position, $design }) =>
    $position === 'bottom-right' &&
    css`
      &::before,
      &::after {
        bottom: ${OFFSET}px;
        right: ${OFFSET}px;
      }

      ${$design === 'middle' &&
      css`
        &::before {
          height: 21px;
          bottom: -11px;
        }
      `}
    `}
`;

interface AnchorLinesProps {
  design?: DesignType;
  position: PositionType;
}

export const AnchorLines: React.ComponentType<AnchorLinesProps> = React.memo(
  ({ position, design = 'corner' }) => {
    return <Wrapper $design={design} $position={position} />;
  }
);
